import { createContext, useEffect, useContext, useState } from "react";
import { fetchCustomerData } from "../dataLayer/crm";
import { useAuth } from "./AuthContext.tsx";

export const CRMContext = createContext();

export const useCRM = () => useContext(CRMContext);

function CRMContextProvider({ children }) {
  const { user } = useAuth();
  const [travellers, setTravellers] = useState([]);
  const [businessProfiles, setBusinessProfiles] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [customerId, setCustomerId] = useState();
  const [preferences, setPreferences] = useState({});
  const [seating, setSeating] = useState("");
  const [meal, setMeal] = useState("");
  const [cities, setCities] = useState("");
  const [cusIdNo, setCusIdNo] = useState("");
  const [selectedBusinessProfile, setSelectedBusinessProfile] = useState({});
  const [progressBarCrm, setProgressBarCrm] = useState(0);

  const updateCustomerData = async () => {
    try {
      if (customerId && typeof customerId !== "undefined") {
        const res = await fetchCustomerData(customerId);
        setCustomerData(res);
        setTravellers(res?.customerNomineeSet);
        setCustomerId(res?.cusCustomerNo);
        setCusIdNo(res?.cusIdNo);
        setPreferences({ ...res?.cusAttrs });
        setSeating(res?.cspAddRef3);
        setMeal(res?.cspAddRef4);
        setCities(res?.cspAddRef2);
        setBusinessProfiles(() => {
          const array = res?.cusAddresses?.filter((item) => {
            if (item.cadAddressType == "BUSINESS") {
              return item;
            }
          });
          return array || [];
        });
      } else {
        setCustomerData([]);
        setTravellers([]);
        setCustomerId();
        setCusIdNo("");
        setPreferences({});
        setSeating("");
        setMeal("");
        setCities("");
      }
    } catch (err) {
      console.warn(err);
    }
  };

  useEffect(() => {
    setCustomerId(user?.cusCustomerNo);
  }, [user]);

  useEffect(() => {
    updateCustomerData();
  }, [customerId]);

  const values = {
    travellers,
    businessProfiles,
    updateCustomerData,
    customerId,
    preferences,
    meal,
    seating,
    cities,
    customerData,
    setCustomerData,
    setProgressBarCrm,
    progressBarCrm,
    cusIdNo,
    selectedBusinessProfile,
    setSelectedBusinessProfile,
    setCities
  };

  return <CRMContext.Provider value={values}>{children}</CRMContext.Provider>;
}

export default CRMContextProvider;
